import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import StatusScreen from '../StatusScreen';
const initialState = {
  hasError: false,
  error: null
};
export class ErrorBoundary extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", initialState);
  }
  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error
    };
  }
  componentDidCatch(error, info) {
    console.error("ErrorBoundary", error, info);
  }
  render() {
    const {
      children,
      size
    } = this.props;
    const {
      hasError,
      error
    } = this.state;
    if (hasError) {
      return /*#__PURE__*/React.createElement(StatusScreen, {
        size: size,
        type: "error",
        title: "An unknown error occurred",
        text: "Error Boundry: React"
      });
    } else {
      return /*#__PURE__*/React.createElement(React.Fragment, null, children);
    }
  }
}
export default ErrorBoundary;